export const BARCODE_SYMBOLOGIES = [
  {
    id: 'code128',
    label: 'Code 128',
    dimension: '1D',
    objectType: 'barcode',
    bcid: 'code128',
    defaultWidth: 80,
    defaultHeight: 25,
    defaultValue: 'ABC123456789',
    supportsText: true,
  },
  {
    id: 'ean13',
    label: 'EAN-13',
    dimension: '1D',
    objectType: 'barcode',
    bcid: 'ean13',
    defaultWidth: 80,
    defaultHeight: 25,
    defaultValue: '7890000000000',
    supportsText: true,
  },
  {
    id: 'upca',
    label: 'UPC-A',
    dimension: '1D',
    objectType: 'barcode',
    bcid: 'upca',
    defaultWidth: 80,
    defaultHeight: 25,
    defaultValue: '036000291452',
    supportsText: true,
  },
  {
    id: 'qrcode',
    label: 'QR Code',
    dimension: '2D',
    objectType: 'qrcode',
    bcid: 'qrcode',
    defaultWidth: 25,
    defaultHeight: 25,
    defaultValue: 'https://etiquetandoapp.com.br',
    supportsText: false,
  },
  {
    id: 'datamatrix',
    label: 'Data Matrix',
    dimension: '2D',
    objectType: 'qrcode',
    bcid: 'datamatrix',
    defaultWidth: 26,
    defaultHeight: 26,
    defaultValue: '01078900000000081725123110L123',
    supportsText: false,
  },
  {
    id: 'pdf417',
    label: 'PDF417',
    dimension: '2D',
    objectType: 'qrcode',
    bcid: 'pdf417',
    defaultWidth: 55,
    defaultHeight: 20,
    defaultValue: 'ID:BR-12345|LOTE:2026-08|VAL:19.90',
    supportsText: false,
  },
  {
    id: 'azteccode',
    label: 'Aztec',
    dimension: '2D',
    objectType: 'qrcode',
    bcid: 'azteccode',
    defaultWidth: 28,
    defaultHeight: 28,
    defaultValue: 'TICKET:AZTEC-2026-08-12',
    supportsText: false,
  },
];

const symbologyMap = new Map(BARCODE_SYMBOLOGIES.map((item) => [item.id, item]));

export function getBarcodeDefinition(symbology = 'code128') {
  return symbologyMap.get(symbology) || symbologyMap.get('code128');
}

export function resolveBarcodeSymbology(object) {
  if (object?.symbology && symbologyMap.has(object.symbology)) return object.symbology;
  if (object?.type === 'qrcode') return 'qrcode';
  return 'code128';
}

export function isBarcodeObject(object) {
  return !!object && (object.type === 'barcode' || object.type === 'qrcode' || symbologyMap.has(object.symbology));
}

export function resolveBarcodeValue(object, values = {}) {
  const fieldValue = object?.field ? values[object.field] : '';
  const fallbackValue = object?.value || getBarcodeDefinition(resolveBarcodeSymbology(object)).defaultValue;
  return fieldValue || fallbackValue;
}

export function createBarcodeObject(id, symbology = 'code128') {
  const definition = getBarcodeDefinition(symbology);
  const base = {
    id,
    type: definition.objectType,
    symbology: definition.id,
    x: 10,
    y: 10,
    w: definition.defaultWidth,
    h: definition.defaultHeight,
    value: definition.defaultValue,
  };

  if (!definition.supportsText) return base;

  return {
    ...base,
    showText: true,
    textSize: 10,
  };
}

export function applyBarcodeSymbology(object, symbology) {
  const currentDefinition = getBarcodeDefinition(resolveBarcodeSymbology(object));
  const nextDefinition = getBarcodeDefinition(symbology);
  const resetSize = currentDefinition.dimension !== nextDefinition.dimension;
  const nextObject = {
    ...object,
    type: nextDefinition.objectType,
    symbology: nextDefinition.id,
    w: resetSize ? nextDefinition.defaultWidth : (object.w ?? nextDefinition.defaultWidth),
    h: resetSize ? nextDefinition.defaultHeight : (object.h ?? nextDefinition.defaultHeight),
    value: object.value || nextDefinition.defaultValue,
  };

  if (nextDefinition.supportsText) {
    return {
      ...nextObject,
      showText: object.showText ?? true,
      textSize: object.textSize ?? 10,
    };
  }

  return {
    ...nextObject,
    showText: undefined,
    textSize: undefined,
  };
}
